import publicIp from 'public-ip';

export const getIp = async () => {
	return await publicIp.v4();
};
